/**
 * Shared companion data — used by WalkingChallenge and AdventureVault.
 */

export const STEP_MILESTONES = [500, 2000, 5000, 10000, 20000, 35000, 50000, 75000, 100000]
export const MAX_STEPS = STEP_MILESTONES[STEP_MILESTONES.length - 1]
export const GOAL_OPTIONS = [1000, 2000, 5000, 7500, 10000, 15000]
export const COMPANION_ORDER = ['carl', 'donut', 'skippy', 'chemist', 'harry', 'hobbit', 'dragon', 'demon']

export const COMPANIONS = {
  carl: {
    id: 'carl',
    name: 'Carl',
    subtitle: 'Dungeon Crawler',
    cardEmoji: '🏃',
    runnerEmoji: '🏃',
    flipRunner: true,
    leftIcon: '🔥', rightIcon: '🔥',
    title: 'DUNGEON CRAWLER CARL',
    cardBg: '#1a1a2e',
    selectedBorder: '#9a4aaa',
    realmBg: 'linear-gradient(135deg, #1a1a2e 0%, #2a1a3e 100%)',
    bg: 'linear-gradient(180deg, #0e0e1e 0%, #1a1a2e 65%, #0a0a14 100%)',
    track: 'linear-gradient(90deg, #3a7a3a 0%, #7a3a7a 100%)',
    goalMsg: "Daily goal reached! Carl nods, begrudgingly impressed.",
    prizes: [
      { emoji: '🗺️', name: 'A soggy tutorial scroll', desc: 'The ink has run. You can just about make out the words "Turn back now."' },
      { emoji: '🧦', name: 'One enchanted sock', desc: 'Previous owner: unknown. Condition: questionable. Enchantment: still unclear.' },
      { emoji: '👙', name: "Carl's legendary lucky underwear", desc: 'Smells of adventure and deeply questionable decisions. +2 to Endurance.' },
      { emoji: '📜', name: "Crawler's Guild scroll", desc: "Partially singed. Someone has signed it 'Donut'. You feel seen." },
      { emoji: '📦', name: 'The Monster Box', desc: 'It is vibrating. There is a small tapping from inside. Do not open.' },
      { emoji: '😤', name: "Princess Donut's glare — framed", desc: 'Gallery quality. She is NOT impressed. Hangs beautifully above a fireplace.' },
      { emoji: '⚔️', name: 'A genuine dungeon weapon', desc: "Still sticky. You don't want to know why. Remarkably effective regardless." },
      { emoji: '🎖️', name: "Crawler's Guild membership", desc: 'Official. Laminated. Your photo was taken without warning. You look terrified.' },
      { emoji: '👑', name: 'You survived the dungeon', desc: 'Carl nods at you. Princess Donut evaluates your footwear and says nothing. You have earned this.' },
    ],
  },

  donut: {
    id: 'donut',
    name: 'Princess Donut',
    subtitle: 'Dungeon Crawler',
    cardEmoji: '🐱',
    runnerEmoji: '🐱',
    flipRunner: false,
    leftIcon: '💎', rightIcon: '✨',
    title: "PRINCESS DONUT'S CRAWL",
    cardBg: '#2d0a38',
    selectedBorder: '#ff80d0',
    realmBg: 'linear-gradient(135deg, #2d0a38 0%, #4a0a50 100%)',
    bg: 'linear-gradient(180deg, #1a0520 0%, #2d0a38 65%, #0f0014 100%)',
    track: 'linear-gradient(90deg, #c050a0 0%, #ff80d0 100%)',
    goalMsg: "Daily goal reached! Princess Donut gives you 4 out of 5 stars. She deducted one for your footwear.",
    prizes: [
      { emoji: '💄', name: "Donut's tutorial lipstick — vintage", desc: 'She signed the tutorial scroll with this. She is very particular about her branding.' },
      { emoji: '🎀', name: 'A spare tiara ribbon', desc: "Donut has standards. This was below them. It is still better than anything you own." },
      { emoji: '🛍️', name: "Donut's dungeon carry bag", desc: 'Rhinestones. Custom. She has three more. You may borrow this one.' },
      { emoji: '📸', name: 'A sponsored post feature', desc: "You appear in the background of Donut's broadcast. Viewers love you. She notices." },
      { emoji: '🌹', name: 'A signed headshot', desc: '"To my loyal viewer. Stay hydrated. — Princess Donut (and Carl, I suppose)"' },
      { emoji: '💅', name: 'Dungeon nail art tutorial', desc: "You didn't think you needed it. You were wrong. These tunnels require glamour." },
      { emoji: '🐾', name: "Donut's personal endorsement", desc: 'She mentioned you in a broadcast. Once. You are now dungeon-famous.' },
      { emoji: '🏆', name: 'The Co-Star Credit', desc: 'Carl gets top billing. You and Donut share a knowing look. It is enough.' },
      { emoji: '👑', name: 'Princess Donut curls up on your lap', desc: 'You are warm. You are trusted. You are part of the team. Do not move.' },
    ],
  },

  skippy: {
    id: 'skippy',
    name: 'Skippy',
    subtitle: 'Expeditionary Force',
    cardEmoji: '🛸',
    runnerEmoji: '👨‍🚀',
    flipRunner: false,
    leftIcon: '⭐', rightIcon: '🌌',
    title: "SKIPPY'S GALAXY RUN",
    cardBg: '#080828',
    selectedBorder: '#4a8aff',
    realmBg: 'linear-gradient(135deg, #080828 0%, #0a0a40 100%)',
    bg: 'linear-gradient(180deg, #020212 0%, #080828 65%, #010110 100%)',
    track: 'linear-gradient(90deg, #1a3aaa 0%, #4a8aff 100%)',
    goalMsg: "Daily goal reached! Skippy declares you 'adequately ambulatory for a primitive biped.'",
    prizes: [
      { emoji: '🥤', name: 'A bent straw from the Dutchman break room', desc: "Skippy says it's a collector's item. He is lying. He just couldn't throw it away." },
      { emoji: '📋', name: "Skippy's mission briefing — mostly redacted", desc: 'The unredacted parts say "Joe" and "do not panic." That is all.' },
      { emoji: '🪐', name: 'A piece of alien moon rock', desc: "Technically owned by a species that no longer exists. Possession is 9/10ths of space law." },
      { emoji: '🎖️', name: "UNEF Service Ribbon", desc: "You're on a list now. Skippy put you there himself. He won't say which list." },
      { emoji: '👾', name: 'A Thuranin food ration', desc: "Do not smell it. Do not ask what's in it. It is nutritionally complete. That is enough." },
      { emoji: '🏅', name: "Skippy's Super Duty Award", desc: 'He invented this award. He gave it to himself first. Now it is yours. Be honoured.' },
      { emoji: '🔩', name: 'A Flying Dutchman hull scrap', desc: 'Slightly radioactive. Glows faintly on Tuesdays. Still better than most Earth technology.' },
      { emoji: '🛸', name: 'An alien artifact — category: mildly dangerous', desc: "Skippy says it's fine. Skippy has been wrong before. Still, probably fine." },
      { emoji: '🌟', name: "Skippy deems you 'not completely useless'", desc: "He said it quietly. He will deny it. But you heard it. Framed. On your wall. Forever." },
    ],
  },

  chemist: {
    id: 'chemist',
    name: 'Crazy Chemist',
    subtitle: 'The Lab',
    cardEmoji: '⚗️',
    runnerEmoji: '🧑‍🔬',
    flipRunner: false,
    leftIcon: '⚗️', rightIcon: '🔬',
    title: "DR. ???'S LAB SPRINT",
    cardBg: '#061a06',
    selectedBorder: '#7aff2a',
    realmBg: 'linear-gradient(135deg, #061a06 0%, #0a2a0a 100%)',
    bg: 'linear-gradient(180deg, #020f02 0%, #061a06 65%, #010801 100%)',
    track: 'linear-gradient(90deg, #1a7a2a 0%, #7aff2a 100%)',
    goalMsg: "Daily goal reached! Results: successful. Side effects: none observed. Yet.",
    prizes: [
      { emoji: '🧪', name: 'Test tube residue — "NOT FOR CONSUMPTION"', desc: "It's fine. Probably. The label is mostly a formality at this point." },
      { emoji: '🥽', name: 'Safety goggles, one lens cracked', desc: 'Still protective. Theoretically. The crack is on the "safe" side according to no established standard.' },
      { emoji: '📝', name: "Lab notebook, pages 12–47 missing", desc: "Best not to ask. The important thing is the rest is fine. The rest is largely fine." },
      { emoji: '💊', name: 'Formula #47 — mostly successful', desc: 'The word "mostly" is doing a lot of work in that sentence. Results were conclusive enough.' },
      { emoji: '🧫', name: 'A petri dish labelled "EXCITING"', desc: 'Something is growing. Whether this is good depends on your relationship with science.' },
      { emoji: '🥼', name: 'An explosion-proof lab coat', desc: "Proof is a strong word. Explosion-resistant. Explosion-adjacent. Explosion-witnessed." },
      { emoji: '💡', name: 'A breakthrough! (unclear what it does)', desc: 'Peer review: pending. Reproducibility: questionable. Significance: enormous, we think.' },
      { emoji: '📰', name: 'Nobel Prize nomination', desc: "Submitted by the doctor themselves. The committee has been 'notified.' Correspondence ongoing." },
      { emoji: '🎓', name: 'You are officially a Mad Scientist', desc: 'The lab coat is yours now. The goggles too. Do not ask what happened to the previous owner.' },
    ],
  },

  harry: {
    id: 'harry',
    name: 'Harry Potter',
    subtitle: 'The Forbidden Forest',
    cardEmoji: '⚡',
    runnerEmoji: '🧙',
    flipRunner: false,
    leftIcon: '🌿', rightIcon: '🪄',
    title: 'THE FORBIDDEN FOREST',
    cardBg: '#0d1e12',
    selectedBorder: '#c0a020',
    realmBg: 'linear-gradient(135deg, #0d1e12 0%, #1a2e18 100%)',
    bg: 'linear-gradient(180deg, #050f08 0%, #0d1e12 65%, #020805 100%)',
    track: 'linear-gradient(90deg, #4a2a8a 0%, #c0a020 100%)',
    goalMsg: "Daily goal reached! A patronus flickers briefly. It's small, but it's there.",
    prizes: [
      { emoji: '🪄', name: 'A first-year spell card', desc: "Wingardium Leviosa, misspelled twice. The wand movement diagram is correct. Mostly." },
      { emoji: '🍬', name: "One Bertie Bott's Every Flavour Bean", desc: 'Flavour: earwax. But you knew the risks when you accepted it. Everyone does.' },
      { emoji: '🦉', name: "A feather from Professor Snape's quill bin", desc: "He doesn't know you have this. It is best to keep it that way. Use it wisely." },
      { emoji: '🌿', name: 'A gnome repelling charm (garden grade)', desc: 'Highly effective. Gnomes will not enjoy your company. This is the goal.' },
      { emoji: '🦅', name: 'A Hippogriff feather', desc: 'You bowed. It considered you. It gave you this. Buckbeak approves. That is enough.' },
      { emoji: '🧥', name: 'An invisibility cloak offcut — knee length', desc: "Your knees are invisible. Everything else: visible. It's a start, honestly." },
      { emoji: '📜', name: 'Owl mail from Dumbledore', desc: '"All will be well in the end. If it is not well, it is not the end." The owl looked exhausted.' },
      { emoji: '🏰', name: 'A Hogwarts continuing education letter', desc: '"Dear Walker, We are pleased to offer a place in our Evening Ambulation Programme."' },
      { emoji: '✨', name: 'A wand cores itself to you', desc: 'The wand chose you. Nobody is more surprised than the wand. But here you both are.' },
    ],
  },

  hobbit: {
    id: 'hobbit',
    name: 'Bilbo Baggins',
    subtitle: 'There and Back Again',
    cardEmoji: '🏔️',
    runnerEmoji: '🧝',
    flipRunner: true,
    leftIcon: '🏔️', rightIcon: '⛰️',
    title: 'THERE AND BACK AGAIN',
    cardBg: '#1e1408',
    selectedBorder: '#c0a050',
    realmBg: 'linear-gradient(135deg, #1e1408 0%, #2e1e0a 100%)',
    bg: 'linear-gradient(180deg, #100a02 0%, #1e1408 65%, #0a0702 100%)',
    track: 'linear-gradient(90deg, #6a4a1a 0%, #c0a050 100%)',
    goalMsg: "Daily goal reached! Second breakfast was earned. Do not let anyone tell you otherwise.",
    prizes: [
      { emoji: '🍳', name: 'Second breakfast leftovers, slightly cold', desc: 'Still excellent. Cold eggs from the Shire beat most hot meals anywhere else.' },
      { emoji: '🪵', name: 'A walking stick from Fangorn Wood', desc: 'Smells of leaves and centuries. Something ancient lives in the grain. It approves of you.' },
      { emoji: '🍞', name: 'Elvish waybread — one square', desc: 'One bite fills the stomach of a grown man. Eat slowly. The elves spent considerable time on this.' },
      { emoji: '🔔', name: 'A Hobbit doorbell, polished, Shire-made', desc: 'Rings with the cheerfulness of a place where nothing bad has ever happened. Yet.' },
      { emoji: '🗺️', name: "A dwarvish map — 'here be dragons' heavily annotated", desc: 'Thorin drew this himself. The annotations grow increasingly alarmed as you approach the middle.' },
      { emoji: '⛓️', name: 'A single mithril button', desc: "Just one button. Made of mithril. Worth more than the entire Shire. Keep it somewhere safe." },
      { emoji: '🌱', name: 'An Ent seedling', desc: 'Plant in good soil. Water thoughtfully. Wait three centuries. Do not rush an Ent.' },
      { emoji: '💍', name: 'A curtain ring from Bag End', desc: "It's not the One Ring. Obviously. Don't be dramatic. It does catch the light rather nicely though." },
      { emoji: '✅', name: 'Gandalf says you may pass', desc: 'That is it. That is the whole prize. You may pass. From a Wizard, this is everything.' },
    ],
  },

  dragon: {
    id: 'dragon',
    name: 'Elder Dragon',
    subtitle: 'The Ancient Bog',
    cardEmoji: '🐲',
    runnerEmoji: '🐲',
    flipRunner: false,
    leftIcon: '🌿', rightIcon: '🌫️',
    title: 'THE ANCIENT BOG',
    cardBg: '#061206',
    selectedBorder: '#2a8a6a',
    realmBg: 'linear-gradient(135deg, #061206 0%, #0a1e0a 100%)',
    bg: 'linear-gradient(180deg, #010801 0%, #061206 65%, #010501 100%)',
    track: 'linear-gradient(90deg, #1a4a1a 0%, #2a8a6a 100%)',
    goalMsg: "Daily goal reached! The swamp stirs. Something ancient and enormous has taken notice.",
    prizes: [
      { emoji: '🪵', name: 'A piece of bog wood, older than memory', desc: 'It has seen kingdoms rise and fall. It has opinions. It shares none of them with you.' },
      { emoji: '🍄', name: 'Swamp mushrooms of dubious origin', desc: 'They glow faintly. This is not considered a bad sign in these parts. Try not to think about it.' },
      { emoji: '🐉', name: 'A scale shed by the Elder Dragon', desc: "Warm to the touch, three centuries after shedding. Dragon warmth is a particular, ancient thing." },
      { emoji: '🗺️', name: "A drowned civilisation's map fragment", desc: "The city it shows no longer exists. The bog swallowed it. You hold the last copy. Be careful." },
      { emoji: '🫙', name: 'Swamp gas — distilled, bottled, potent', desc: "Do not open near flame. Do not open near water. The lid is largely decorative." },
      { emoji: '💀', name: "A bog mummy's ring", desc: "Still has part of a finger attached. This is entirely normal here. The ring itself is lovely." },
      { emoji: '📜', name: 'An ancient dragon contract — 3,000-year terms', desc: 'The fine print is in a language that predates written language. You have agreed to something.' },
      { emoji: '🔮', name: 'A draconic word of power', desc: 'Use sparingly. The bog hears every utterance. Something in the deep water always answers.' },
      { emoji: '👁️', name: 'The Elder Dragon acknowledges you', desc: 'One eye opens. Regards you across three millennia of indifference. Closes again. This is everything.' },
    ],
  },

  demon: {
    id: 'demon',
    name: 'A Demon',
    subtitle: 'The Ninth Circle',
    cardEmoji: '😈',
    runnerEmoji: '😈',
    flipRunner: false,
    leftIcon: '🔥', rightIcon: '💀',
    title: 'THE NINTH CIRCLE',
    cardBg: '#2a0505',
    selectedBorder: '#ff4a0a',
    realmBg: 'linear-gradient(135deg, #2a0505 0%, #3a0808 100%)',
    bg: 'linear-gradient(180deg, #1a0000 0%, #2a0505 65%, #0f0000 100%)',
    track: 'linear-gradient(90deg, #8a0a0a 0%, #ff4a0a 100%)',
    goalMsg: "Daily goal reached! Your soul debt has been reduced by 0.004%. The demon is keeping score.",
    prizes: [
      { emoji: '📄', name: 'A mild soul fragment — 0.003 Infernal credits', desc: "Technically yours. You left it between km 1 and 2. It has been filed appropriately." },
      { emoji: '🅿️', name: "A demon's parking ticket — unpaid", desc: 'Issued in the 4th circle. Overdue by 800 years. Late fees: immeasurable. Not your problem. Yet.' },
      { emoji: '🫙', name: 'Brimstone cologne — notes of sulphur and regret', desc: 'Surprisingly wearable. You will never smell ordinary again. This is a gift, not a warning.' },
      { emoji: '🕯️', name: 'A hellfire torch that burns cold on Tuesdays', desc: "The cold doesn't hurt. The light shows things that aren't there. Both are normal." },
      { emoji: '📜', name: 'An imp contract of minor servitude', desc: "Terms: 'do what I say, roughly, when convenient.' The imp is not thrilled. You are, slightly." },
      { emoji: '📓', name: "The Demon's ledger — debts re-categorised as 'earned'", desc: 'A technicality. A loophole. An ancient contractual oversight. Enjoy it while it lasts.' },
      { emoji: '🦴', name: "A hellhound's chew toy — still smoking", desc: "The hellhound let you have it. This either means you're trusted or you're next. Unclear." },
      { emoji: '📖', name: 'A grimoire of moderate power', desc: "The dangerous spells are in the index, helpfully labelled 'Do Not.' You have been warned." },
      { emoji: '🎩', name: 'You walked through hell and back', desc: "The devil tips his hat. The hat is real. The gesture is sincere. This is as warm as he gets." },
    ],
  },
}
